/*
 *
 * OperationLoyalty
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 24-Jul-2025
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  XLSTransactionId: (
    <PortalMessage id='t.app.orders.operation.loyalty.bonusOperationId' defaultMessage='XLS Transaction ID' />
  ),
  totalRedeemedPoints: <PortalMessage id='t.app.orders.operation.loyalty.pointsUsed' defaultMessage='Total Redeemed Points' />,
  totalRedemptionAmount: <PortalMessage id='t.app.orders.operation.loyalty.bonusAmount' defaultMessage='Total Redemption Amount' />,
  totalAwardedPoints: <PortalMessage id='t.app.orders.operation.loyalty.pointsEarned' defaultMessage='Total Awarded Points' />,
  discountedPaymentAmount: <PortalMessage id='t.app.orders.operation.loyalty.finalAmount' defaultMessage='Final amount' />
}
export const captions = defineMessages({
  points: {
    id: 't.app.orders.operation.loyalty.points',
    defaultMessage: 'points'
  }
})

export default formattedMessage
